<div class="building-reassignment-view">
  <div class="back-button" (click)="onBackClick()">
    <mat-icon>arrow_back</mat-icon>
    <span>Back to Reassignment Types</span>
  </div>

  <div class="building-reassignment-content">
    <!-- Step 1: Select New Building -->
    <div class="step-container">
      <h2 class="step-title">Step 1: Select New Building</h2>
      <div class="dropdown-container">
        <label class="dropdown-label">Select new building:</label>
        <select
          class="building-dropdown"
          [(ngModel)]="selectedNewBuilding"
          (change)="onNewBuildingSelected(selectedNewBuilding)"
        >
          <option value="">Select new building…</option>
          <option *ngFor="let building of buildings" [ngValue]="building">
            {{ building.buildingName }}
          </option>
        </select>
      </div>
    </div>

    <!-- Step 2: Filter Staff by Building -->
    <div class="step-container" *ngIf="selectedNewBuilding">
      <h2 class="step-title">Step 2: Filter Staff by Building</h2>
      <div class="filter-container">
        <label class="filter-label">Choose a building to filter staff:</label>
        <select
          class="filter-dropdown"
          [(ngModel)]="selectedFilterBuilding"
          (change)="onFilterBuildingSelected(selectedFilterBuilding)"
        >
          <option value="">Choose a building to filter staff…</option>
          <option *ngFor="let building of buildings" [ngValue]="building">
            {{ building.buildingName }}
          </option>
        </select>
      </div>
    </div>

    <!-- Staff List -->
    <div
      class="step-container"
      *ngIf="selectedFilterBuilding && userList.length > 0"
    >
      <h2 class="step-title">Staff List</h2>
      <div class="staff-list-container">
        <div class="list-header">
          <h3>Available Staff</h3>
          <div class="select-all-container">
            <mat-checkbox
              [checked]="selectAllUsers"
              [indeterminate]="
                selectedUsers.length > 0 &&
                selectedUsers.length < filteredUserList.length
              "
              (change)="toggleSelectAllUsers()"
              [disabled]="filteredUserList.length === 0"
            >
              Select All
            </mat-checkbox>
          </div>
        </div>

        <div class="search-container">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="Search staff…"
            [(ngModel)]="userSearchText"
            (input)="onUserSearchChange(userSearchText)"
            class="search-input"
          />
        </div>

        <div class="list-content">
          <div *ngFor="let user of filteredUserList" class="list-item">
            <mat-checkbox
              [checked]="isUserSelected(user)"
              (change)="toggleUserSelection(user)"
              [disabled]="!user || !user.id"
            >
            </mat-checkbox>
            <span class="item-text"
              >{{ user?.firstName }} {{ user?.lastName }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state for no staff in building -->
    <div
      class="step-container empty-state"
      *ngIf="selectedFilterBuilding && userList.length === 0"
    >
      <div class="empty-state-content">
        <mat-icon class="empty-icon">people_outline</mat-icon>
        <h3>No staff are currently assigned to this building.</h3>
      </div>
    </div>

    <!-- Assignment Panel -->
    <div class="step-container" *ngIf="selectedUsers.length > 0">
      <h2 class="step-title">Assign Selected Staff to Building</h2>
      <div class="transfer-container">
        <div class="selected-staff-list">
          <h3>Selected Staff ({{ selectedUsers.length }})</h3>
          <div class="selected-staff-items">
            <div
              *ngFor="let user of selectedUsers"
              class="selected-staff-item"
            >
              <span>{{ user.firstName }} {{ user.lastName }}</span>
              <button
                class="remove-btn"
                (click)="toggleUserSelection(user)"
                title="Remove from selection"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <div class="assignment-info">
          <h3>Assignment Details</h3>
          <div class="building-info">
            <strong>New Building:</strong>
            {{ selectedNewBuilding.buildingName }}
          </div>
          <div class="staff-count">
            <strong>Staff Count:</strong> {{ selectedUsers.length }}
          </div>
        </div>
      </div>

      <!-- Assignment Type Selection -->
      <div class="assignment-type-selection">
        <h3>Assignment Type</h3>
        <div class="assignment-options">
          <div
            class="assignment-option"
            [class.selected]="assignmentType === 'move'"
            (click)="assignmentType = 'move'"
          >
            <div class="option-header">
              <div class="option-radio">
                <input
                  type="radio"
                  name="assignmentType"
                  value="move"
                  [(ngModel)]="assignmentType"
                  [checked]="assignmentType === 'move'"
                />
              </div>
              <div class="option-content">
                <div class="option-title">
                  <mat-icon class="option-icon">swap_horiz</mat-icon>
                  <span class="title-text">Move Staff</span>
                </div>
                <div class="option-description">
                  Remove from
                  <strong>"{{ selectedFilterBuilding?.buildingName }}"</strong>
                  and assign to
                  <strong>"{{ selectedNewBuilding.buildingName }}"</strong>
                </div>
              </div>
            </div>
          </div>

          <div
            class="assignment-option"
            [class.selected]="assignmentType === 'add'"
            (click)="assignmentType = 'add'"
          >
            <div class="option-header">
              <div class="option-radio">
                <input
                  type="radio"
                  name="assignmentType"
                  value="add"
                  [(ngModel)]="assignmentType"
                  [checked]="assignmentType === 'add'"
                />
              </div>
              <div class="option-content">
                <div class="option-title">
                  <mat-icon class="option-icon">add_circle</mat-icon>
                  <span class="title-text">Add Staff</span>
                </div>
                <div class="option-description">
                  Keep in
                  <strong>"{{ selectedFilterBuilding?.buildingName }}"</strong>
                  and also assign to
                  <strong>"{{ selectedNewBuilding.buildingName }}"</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button
          class="assign-btn"
          (click)="assignBuildingToUsers()"
          [disabled]="!selectedNewBuilding || selectedUsers.length === 0"
        >
          {{ assignmentType === "move" ? "Move" : "Add" }}
          {{ selectedUsers.length }} Staff Member(s) to
          {{ selectedNewBuilding.buildingName }}
        </button>
      </div>
    </div>

    <!-- Validation message -->
    <div
      class="step-container validation-message"
      *ngIf="selectedUsers.length > 0 && !selectedNewBuilding"
    >
      <div class="validation-content">
        <mat-icon class="validation-icon">warning</mat-icon>
        <span>Select a new building before assigning.</span>
      </div>
    </div>
  </div>
</div>

